// extracted by mini-css-extract-plugin
export default {"frame_logo":"AppLogo_frame_logo__mnIgf"};